const memberSwiper = (els) => {
  els.forEach((item) => {
    const progressbarEl = item.querySelector(".js-member-swiper__progressbar");
    new Swiper(item, {
      spaceBetween: 10,
      pagination: {
        el: progressbarEl,
        type: "progressbar",
      },
    });
  });
};
